module.exports = __webpack_public_path__ + "img/car_red.c9a0d27c.svg";